import { css } from '@emotion/react';
import { useTheme } from '@mui/material';
import Colors from '../theme/colors';

const useLoginFooterStyles = () => {
  const theme = useTheme();
  return {
    footerLinks: css({
      [theme.breakpoints.up('md')]: {
        whiteSpace: 'nowrap',
        border: '0px solid transparent',
        '&:hover': {
          fontWeight: 'bold',
        },
      },
    }),
    loginFooterContainer: css({
      backgroundColor: Colors.blue,
      padding: `${theme.spacing(0)} ${theme.spacing(7)} ${theme.spacing(0)} ${theme.spacing(9)}`,
      paddingLeft: '24px',
      fontSize: 14,
      position: 'relative',
      color: Colors.white,
      '& > .MuiGrid-item': {
        padding: '13px 0',
        [theme.breakpoints.up('md')]: {
          padding: '24px 32px 24px 0',
        },
        '&:first-of-type': {
          padding: '14px 35px 5px 0',
          [theme.breakpoints.up('md')]: {
            padding: '14px 35px 24px 0',
          },
        },
        lineHeight: '16.41px',
        '&:last-child': {
          alignItems: 'flex-start',
          padding: '45px 0 24px 0',
          fontWeight: 600,
          [theme.breakpoints.up('md')]: {
            margin: '0 0 0 auto',
            textAlign: 'right',
            padding: '24px 0 24px 0',
            alignItems: 'center',
            fontWeight: 400,
          },
          '& .MuiGrid-item': {
            padding: '10px 0 0 0',
            fontWeight: 400,
            [theme.breakpoints.up('md')]: {
              padding: '0',
            },
          },
        },
      },
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    }),
    logoContainer: css({
      paddingTop: '10px',
      '& .MuiGrid-item': {
        fontSize: '11px',
        '&:nth-of-type(2)': {
          padding: '17px 0 0 0',
        },
      },
    }),
  };
};

export default useLoginFooterStyles;
